import { Box, Button, Fade, Grid, Paper, Slide, styled } from "@mui/material"
import { useEffect, useMemo, useState } from "react"
import { useTranslation } from "react-i18next"
import { FullContainer } from "../../components/FullContainer"
import { useDialogAPI } from "../dialogs/context/DialogProvider"
import { useSfxAPI } from "../sfx/context/SfxProvider"
import { GameHeader } from "./components/GameHeader"
import { useGamesAPI, useGamesData } from "./context/GamesProvider"
import { DndGameModule } from "./games/dnd/DndGameModule"
import { FillGameModule } from "./games/fill/FillGameModule"
import { SortGameModule } from "./games/sort/SortGameModule"

export const GamesModule = () => {
  console.info("GamesModule render")

  //  OTHER CONTEXTS
  const { t } = useTranslation()
  const { isOpen, current, isValid } = useGamesData()
  const { closeGame, setProgress, unloadGame } = useGamesAPI()
  const { nextDialog } = useDialogAPI()
  const { play } = useSfxAPI()

  //  LOGIC
  const [showImg, setShowImg] = useState(false)

  useEffect(() => {
    if (isValid) play("success")
  }, [isValid, play])

  useEffect(() => {
    if (current)
      setShowImg(true)
    else
      setShowImg(false)
  }, [current])

  const GameRender = useMemo(() => {
    if (current === undefined) {
      closeGame()
      nextDialog()
      return <></>
    } else {
      switch (current && current.type) {
        case "dnd":
          return <DndGameModule />
        case "fill":
          return <FillGameModule />
        case "sort":
          return <SortGameModule />
        default:
          return <></>
      }
    }
  }, [current, closeGame, nextDialog])

  //  HANDLES
  const handleOnClick = () => {
    closeGame()
  }

  const handleOnExited = () => {
    setProgress(0)
    unloadGame()
    nextDialog()
  }

  return (
    <FullContainer>
      {/* background */}
      <Fade in={isOpen} timeout={600} appear>
        <Paper variant="fade"></Paper>
      </Fade>

      {/* game zone */}
      <Slide
        in={isOpen}
        timeout={600}
        appear
        direction="left"
        onExited={handleOnExited}
      >
        <Paper variant="gameZone" elevation={3}>
          {/* <Box
            sx={{
              position: "fixed",
              backgroundColor: "#fff",
              width: "80%",
              zIndex: 1000,
              margin: "-1em",
            }}
          >
            <GameHeader />
          </Box> */}
          <Grid container height={"100%"} alignContent={"flex-start"}>
            <GameHeader />
            <Grid item container xs={12} justifyContent={"center"}>
              {showImg && <img src={`./img/games/${current?.id}.png`} height={"300"} onError={(e) => {
                setShowImg(false)
              }} />}
            </Grid>
            {GameRender}
          </Grid>
        </Paper>
      </Slide>

      {/*next button*/}
      <Fade in={isOpen} timeout={600} appear>
        <GameModuleButtonContainer>
          <Button
            onClick={handleOnClick}
            disabled={!isValid && process.env.REACT_APP_DEV_MODE !== "true"}
          >
            {t(`ui.button.next`)}
          </Button>
        </GameModuleButtonContainer>
      </Fade>
    </FullContainer>
  )
}

//  STYLED
const GameModuleButtonContainer = styled(Box)(() => ({
  position: "absolute",
  bottom: "0",
  right: "0",
  padding: "2em",
}))
